import React, { useRef } from 'react';
import { arrowRIcon, dots3VerticalIcon } from '../../static/svgs';
import { formatBadgeCount } from '../../utils/badgeCounts';
import CompanyPaymentBlock from './CompanyPaymentBlock';
import './companyPicker.css';

const LONG_PRESS_MS = 500;

function CompanyPickerList({
    users,
    onSelect,
    className = '',
    badgeByUserId = null,
    onMenuClick = null,
    onPaymentClick = null,
    showPaymentInfo = false,
    paymentByUserId = null,
    onMarkUnread = null,
}) {
    const longPressTimerRef = useRef(null);
    const longPressTriggeredRef = useRef(false);

    if (!users || users.length === 0) {
        return null;
    }

    const clearLongPress = () => {
        if (longPressTimerRef.current) {
            clearTimeout(longPressTimerRef.current);
            longPressTimerRef.current = null;
        }
    };

    const openMarkUnread = (user, clientX, clientY) => {
        if (!onMarkUnread) return;
        onMarkUnread(user, { x: clientX, y: clientY });
    };

    const handleContextMenu = (e, user) => {
        if (!onMarkUnread) return;
        e.preventDefault();
        e.stopPropagation();
        openMarkUnread(user, e.clientX, e.clientY);
    };

    const handleTouchStart = (e, user) => {
        if (!onMarkUnread) return;
        longPressTriggeredRef.current = false;
        const touch = e.touches?.[0];
        if (!touch) return;
        const { clientX, clientY } = touch;
        clearLongPress();
        longPressTimerRef.current = setTimeout(() => {
            longPressTriggeredRef.current = true;
            openMarkUnread(user, clientX, clientY);
        }, LONG_PRESS_MS);
    };

    const handleTouchEnd = () => {
        clearLongPress();
    };

    const handleTouchMove = () => {
        clearLongPress();
    };

    return (
        <div className={`company-picker-list company-picker-panel ${className}`.trim()}>
            {users.map((user) => {
                const badge = badgeByUserId
                    ? formatBadgeCount(badgeByUserId[user.user_id])
                    : null;
                const payment = showPaymentInfo ? paymentByUserId?.[user.user_id] : null;

                return (
                <div
                    key={user.user_id}
                    className={`company-picker-item${showPaymentInfo ? ' company-picker-item--with-payment' : ''}`}
                    onContextMenu={onMarkUnread ? (e) => handleContextMenu(e, user) : undefined}
                    onTouchStart={onMarkUnread ? (e) => handleTouchStart(e, user) : undefined}
                    onTouchEnd={onMarkUnread ? handleTouchEnd : undefined}
                    onTouchMove={onMarkUnread ? handleTouchMove : undefined}
                    onTouchCancel={onMarkUnread ? handleTouchEnd : undefined}
                >
                    {onMenuClick && (
                        <button
                            type="button"
                            className="company-picker-menu-btn"
                            aria-label={`Меню ${user.company_name}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                onMenuClick(user);
                            }}
                        >
                            {dots3VerticalIcon}
                        </button>
                    )}
                    <button
                        type="button"
                        className={`company-picker-main-btn manrope-bold${showPaymentInfo ? ' company-picker-main-btn--with-payment' : ''}`}
                        onClick={() => {
                            if (longPressTriggeredRef.current) {
                                longPressTriggeredRef.current = false;
                                return;
                            }
                            onSelect(user);
                        }}
                    >
                        <div className="company-picker-main-top">
                            <span className="company-picker-name">{user.company_name}</span>
                            <span className="company-picker-trailing">
                                {badge && (
                                    <span className="company-picker-badge">{badge}</span>
                                )}
                                {arrowRIcon}
                            </span>
                        </div>
                        {showPaymentInfo && payment && (
                            <CompanyPaymentBlock
                                payment={payment}
                                user={user}
                                onPaymentClick={onPaymentClick}
                            />
                        )}
                    </button>
                </div>
                );
            })}
        </div>
    );
}

export default CompanyPickerList;
